import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

// The migration review lives on the Intents page now; keep old links.
export const Route = createFileRoute("/intents")({
  validateSearch: zodValidator(
    z.object({ tenantId: z.string().uuid().optional().catch(undefined) }),
  ),
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack redirects by throwing
    throw redirect({
      to: "/intent-hub",
      search: { tenantId: search.tenantId, tab: "migration" },
    });
  },
});
